import axios from 'axios'
import { Message, Loading } from 'element-ui'

// 提示问题
function warningMessage (str) {
  Message && Message({
    message: str || '系统发生未知错误',
    duration: 4000,
    type: 'warning',
    showClose: true
  })
}

// 连接超时时间
axios.defaults.timeout = 600000
// 跨域是否需要凭证
axios.defaults.withCredentials = false
// 头部添加
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

// 请求拦截器
axios.interceptors.request.use(res => {
  // console.log('请求拦截器', res)
  return res
})

// 响应拦截器
axios.interceptors.response.use(res => {
  // console.log('响应拦截器', res)
  return res.data
},
  // 新增错误拦截器
  error => {
    console.log('响应错误拦截器', error)
    if (error.response) {
      const { status, data } = error.response
      console.log(status, data)
      switch (status) {
        case 400:
          warningMessage(data?.message || '请求参数错误 (400)')
          break
        case 401:
          warningMessage('未授权，请重新登录')
          // 可跳转登录页
          break
        case 403:
          warningMessage('拒绝访问')
          break
        case 404:
          warningMessage('请求资源不存在')
          break
        case 500:
          warningMessage('服务器内部错误')
          break
        default:
          warningMessage(data?.message || `请求失败 (${status})`)
      }
    } else if (error.request) {
      warningMessage('网络异常，请检查连接')
    } else {
      warningMessage(error.message || '请求配置错误')
    }
    // 继续抛出错误，让调用方也能捕获
    return Promise.reject(error)
  })

function request (option) {
  return new Promise(function (resolve, reject) {
    const params = {
      ...option,
      headers: option.headers || {}
    }

    // FormData 上传时不设置 Content-Type，让浏览器自动带上 multipart/form-data; boundary=...
    if (!option.isFormData) {
      params.headers['Content-Type'] = 'application/json;charset=utf-8'
    }

    // Loading，参数加loading代表此接口需要遮罩层
    let loading
    let data = option[option.method === 'POST' ? 'data' : 'params']
    if (data && data.loading) {
      loading = Loading.service({
        text: typeof (data.loading) === 'string' ? data.loading : '',
        background: 'rgba(255, 255, 255, 0.6)'
      })
      delete data.loading
    }

    // FormData 上传：临时移除全局 Content-Type 默认值，让浏览器自动设置 multipart/form-data
    let savedContentType
    if (option.isFormData) {
      savedContentType = axios.defaults.headers['Content-Type']
      delete axios.defaults.headers['Content-Type']
      delete params.headers['Content-Type']
    }

    axios(params).then((res) => {
      loading && loading.close()
      // 恢复全局默认 Content-Type
      if (option.isFormData) axios.defaults.headers['Content-Type'] = savedContentType
      // console.log('请求成功', res)

      if (res) {
        resolve(res)
      } else {
        reject(res)
        // warningMessage(res)
      }
    }).catch((err) => {
      loading && loading.close()
      // 恢复全局默认 Content-Type
      if (option.isFormData) axios.defaults.headers['Content-Type'] = savedContentType
      reject(err)

    })
  })
}

export function httpRequest (option) {
  return request(option)
}

export function downloadFile (option) {
  return new Promise((resolve, reject) => {
    request(option).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

//文件转base64
export function getFileData (url) {
  return new Promise((reslove, reject) => {
    axios({
      method: 'get',
      url: url,
      responseType: 'blob'
    }).then((data) => {
      const blob = data
      const fileReader = new FileReader()
      fileReader.readAsDataURL(blob)
      fileReader.onloadend = function (e) {
        const base64 = atob(
          e.target.result.substring(e.target.result.indexOf(',') + 1)
        )
        reslove(base64)
      }
    }).catch((err) => {
      reject(err)
    })
  })
}
